export default {
   
  farm: {
    locationType: "Tipo de Localização",
    viewLocation: "Ver Localização",
    Circular: "Circular",
    Polygon: "Polígono",
    selectFarmToEnableCalenderView: "Selecione Farm para habilitar a visualização do calendário",
    farmActivities: "Atividades da fazenda",
    scheduledActivities: "Atividades Agendadas",
    completedActivities: "Atividades Concluídas",
    listView: "Visualização de lista",
    calendarView: "Visualização do Calendário",
    search: "Buscar",
    filterByFarmName: "Filtrar por Nome da Fazenda",
    filterByCropType: "Filtrar por Tipo de Cultura",
    filterByStartDate: "Filtrar por Data de Início",
    cropName: "Nome da Cultura",
    Name: "Nome",
    activities: "Atividades",
    startDate: "Data de Início",
    endDate: "Data de Término",
    activityDetails: "Detalhes da Atividade",
    customization: "Personalização",
    recordsPerpage: "Registros por Página",
    restoreDefault: "Restaurar Padrão",
    save: "Salvar",
    apply: "Aplicar",
    importFarmsInBulk: "Importar Fazendas em bloco",
    bulkImportNote: "Baixe e use os modelos abaixo para importar fazendas em bloco:",
    radius: "Raio",
    radiusInfo: "Especifica a distância de um ponto central à borda externa de uma área circular.",
    radiusUnitInfo: "Refere-se a uma quantidade padrão usada como base para a medição.",
    importFarms: "Importar fazendas a granel",
    importingNote: "Seu arquivo carregado está sendo processado.\nNão clique em cancelar, fechar ou atualizar esta página para evitar interrupções.",
    addFarm: "Adicionar Fazenda",
    importantNoteDetail: "Por favor, use os modelos fornecidos acima para uploads em massa. Outros formatos resultarão em falha.",
    importantNote: " Nota Importante",
    selectFileToUpload: "Selecione o arquivo para fazer upload",
    generateReport: "Gerar relatório",
    farmRegistration: "Registro de fazenda",
    farmInformation: "Informação da fazenda",
    iAmNotFarmer: "Eu não sou um produtor",
    farmID: "ID da Fazenda",
    farmId: "ID da Fazenda",
    farmIdPlaceHolder: "Farm id place holder" ,
    farmers: "Agricultores" ,
    farmName: "Nome da fazenda" ,
    nameOfTheFarm: "Nome da fazenda" ,
    farmRegistrationId: "Id de registro da fazenda" ,
    farmerRegistrationId: "Id de registro do agricultor" ,
    farmerFirstName: "Primeiro nome do agricultor" ,
    farmerMiddleName: "Nome do meio do agricultor" ,
    farmerLastName: "Sobrenome do agricultor" ,
    farmerId: "Id do agricultor" ,
    ownershipType: "Tipo de propriedade" ,
    certifications: "Certificações" ,
    productionType: "Tipo de produção" ,
    farmTitleDocument: "Documento de título da fazenda" ,
    dropHere: "ou arraste e solte aqui" ,
    farmLocationSize: "Tamanho da localização da fazenda" ,
    farmStateInfo: "Informações do estado da fazenda" ,
    farmLocationAddressInfo: "Informações do endereço da localização da fazenda" ,
    pleaseClickToChooseLocation: "Por favor clique para escolher localização" ,
    country: "País" ,
    countryH: "País h" ,
    provinceState: "Estado/Província" ,
    provinceStateInfo: "Informações do estado província" ,
    cityInfo: "Informações da cidade" ,
    streetNumber: "Número da rua" ,
    streetNumberInfo: "Informações do número da rua" ,
    addGeofenceForThisFarm: "Adicionar polígono para esta fazenda" ,
    useGeoFencingFeature: "Usar recurso de delimitação da fazenda" ,
    uploadShapeFile: "Carregar polígono da fazenda" ,
    cancel: "Cancelar",
    register: "Registrar",
    goals: "Objetivos",
    dashboard: "Painel",
    farms: "Fazendas",
    registerAfarm: "Registre uma fazenda",
    farmLocationAddress: "Endereço da localização da fazenda",
    city: "Cidade",
    streetNo: "Número da rua",
    "UPDATEGEOFENCEFORTHISFARM": "ATUALIZAR GEOFENCE PARA ESTA FARMACIA",
    "AddZonestothisfarm": "Adicionar zonas para esta fazenda",
    "ViewZonestothisfarm": "Ver zonas para esta fazenda",
    farmInfo: "Informações da fazenda",
    locationAndSize: "Localização e tamanho",
    farmReports: "Relatórios da fazenda",
    editFarm: "Editar fazenda",
    deleteFarm: "Excluir fazenda",
    confirmBulkDeleteFarm:
      "Tem certeza de que deseja excluir {count} fazenda(s) selecionada(s)?",
    bulkDelete: "Excluir em bloco",
    selectFarmsToDelete: "Selecione pelo menos uma fazenda para excluir.",
    bulkDeleted: "{count} fazenda(s) foram excluída(s).",
    basicInformation: "Informações básicas",
    primaryGeofence: "Geocerca primária",
    geofenceName: "Nome da geocerca",
    geofenceCategoryName: "Nome da categoria da geocerca",
    farmLocation: "Localização da fazenda",
    address: "Endereço",
    latitude: "Latitude",
    longitude: "Longitude",
    areaUnit: "Unidade de área",
    confirmation: "Confirmação", 
    saveAndConfirmationMessage: "Tem certeza de que deseja salvar as alterações?",
    confirmDownload: "Deseja baixar todos os anexos em formato PDF?",
  
    selectProductionPlacesUsingLots: "Selecione os locais de produção usando lotes",
    SelectProductionPlacesUsingFarms: "Selecione os locais de produção usando fazendas",
  
    accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "De acordo com o EUDR, fazendas com menos de 4 hectares não exigem um polígono.",
    circularAreaEquivalent: "Nesses casos, usaremos uma área circular equivalente ao tamanho da fazenda, com o ponto GPS fornecido como centro para verificar o desmatamento. Quando o tamanho da fazenda não for fornecido, usaremos 4 hectares por padrão.",
    ifTheFarmsAreSmallerPleaseEnterTheStandardSizeInTheFieldBelow: "Se as fazendas forem menores, insira o tamanho padrão no campo abaixo.",
    defaultCircularGeofence: "Fazendas sem geofence ou sem informações sobre seu tamanho receberão um geofence circular padrão de 4 hectares. Se o tamanho médio da fazenda for menor que 4 hectares, altere o tamanho padrão clicando no botão 'Editar' abaixo.",
    defaultAreaValueSpecified: "Fazendas sem geofence ou área receberão o valor de área padrão especificado abaixo e serão atribuídas a um geofence de ponto com raio circular.",
    uploadFileBeingProcessed: "Seus arquivos carregados estão sendo processados. Você será redirecionado para a página de lista de relatórios de due diligence para ver o status.",
    processingLocations: "Processando Locais",
  
    lotId: "ID do Lote",
    product: "Produto",
    qualityGade: "Grau de Qualidade",
    processingDate: "Data de Processamento",
  
    importProductionPlaceTT: "Permite aos usuários importar dados do local de produção usando opções de upload ou download de arquivos.",
    internalReferenceNumberTT: "Um número de referência ou código utilizado internamente para organizar e gerenciar relatórios de due diligence.",
  
    onlyShowFarmsWithIssues: "Mostrar apenas fazendas com problemas",
    searchFarmName: "Buscar pelo Nome da Fazenda",
    pleaseSelectFarmType: "Por favor selecione o tipo de Fazenda",
    deforestationReports: "Relatório(s) de Desmatamento",
    stateStatement: "Região do país onde a fazenda está localizada.",
    countryState: "País onde a fazenda está localizada.",
    cityStatement: "Cidade onde a fazenda está localizada.",
    farmAddress: "Endereço da Localização da Fazenda",
    farmNumber: "Número da Fazenda",
    primaryLocation: "Localização Primária",
    addNewLocation: "Adicionar Nova Localização",
    totalFarmSize: "Tamanho Total da Fazenda",
    addNewZone: "Adicionar Nova Zona",
    locationZone: "Zona de Localização",
    noZoneMessage: "Nenhuma zona foi registrada ainda.",
    noZoneRequest: "Por favor, clique em Adicionar Nova Zona para criar uma zona para esta fazenda.",
    farmOwnershipType: "Tipo de Propriedade do Agricultor",
    farmGoals: "Objetivos da Fazenda",
    farmCertifications: "Certificações da Fazenda",
    enterHere: "Insira aqui",
    farmerName: "Nome do Agricultor",
    farmerNameId: "Nome do Agricultor / ID",
    farmNameLocation: "Nome da Fazenda/ Localização",
    personal: "Pessoal",
    community: "Comunidade",
    factory: "Estação de Compra",
    farmType: "Tipo de Fazenda",
    "organic": "Orgânico",
    "conventional": "Convencional",
    
  technicianName: "Nome do técnico",
  regBy: "Registrado por",
  regDate: "Data de registro",
  geographicLocation: "Localização geográfica",
  searchLocation: "Procurar localização",
  pleaseChooseOneOfTheOption: "Por favor escolha uma das opções",
  uploadGeofence: "Carregar geocerca",
  upload: "Carregar",
  reports: "Relatórios",
  avocado: "Abacate",
  avocadoTrees: "Árvores de abacate",
  addNewFarmLocation: "Adicionar nova localização da fazenda",
  useGeofenceTool: "Usar ferramenta de geocerca",
  geofenceIsRequiredForSatelliteReport: "Nota: A geocerca é necessária para relatórios de satélite",
  secondaryLocation: "Localização secundária",
  editFarmLocation: "Editar localização da fazenda",
  addZone: "Adicionar zona",
  nameOfTheZone: "Nome da zona",
  zoneDetails: "Detalhes da zona",
  perimeter: "Perímetro",
  area: "Área",
  zoneName: "Nome da zona",
  farmGeofence: "Geocerca da fazenda",
  circularGeofence: "Geocerca circular",
  polygonGeofence: "Geocerca poligonal",
  actions: "Ações",
  editZone: "Editar zona",
  numberOfGroups: "Número de grupos",
  numberOfTrees: "Número de árvores",
  group: "Grupo",
  groupName: "Nome do grupo",
  numberOfAnimals: "Número de animais",
  status: "Status",
  walkAndMeasure: "Caminhar e medir",
  clearGeofence: "Limpar geocerca",
  deleteSelectedVertex: "Excluir vértice selecionado",
  farmRadius: "Raio da fazenda",
  locationDisabledMessage: "Sua localização está desativada. Por favor, procure sua localização nos menus à esquerda.",
  yourDistanceIs: "Sua distância é",
  selectFarmToEnableCalendarView: "Por favor, selecione uma fazenda para habilitar a visualização do calendário",
  noFarm: "Nenhuma fazenda foi registrada ainda.",
  noFarmDescription: "Por favor, clique nos botões abaixo para começar.",
  farmsAccessControl: "Controle de Acesso às Fazendas",
  chooseTheUserYouWantToManageFarmAccessFor: "Escolha o(s) usuário(s) para o(s) qual(is) deseja gerenciar o acesso à fazenda.",
  selectTheFarmYouWantToManageAccessFor: "Selecione a fazenda para a qual deseja gerenciar o acesso.",
  proceedWithSelected: "Prosseguir com selecionado",
  userRole: "Função do Usuário",
  userRoleInfo: "Função do usuário. A função do usuário determina as permissões que o usuário tem na fazenda.",
  usersSelected: "usuários selecionados",
  viewFarmAccess: "Ver Acesso à Fazenda",
  selectUser: "Selecionar Usuário",
  recordsPerPage: "Registros por página",
  print: "Imprimir",
  custom: "Personalizado",
  records: "Registros",
  accessControl: "Controle de Acesso",
  all: "Todos",
  farmer: "Agricultor",
  technician: "Técnico",
  userNameAndId: "Nome e ID do Usuário",
  email: "E-mail",
  userRoleAndRegDate: "Função do Usuário / Data de Registro",
  access: "Acesso",
  active: "Ativo",
  inactive: "Inativo",
  na: "N/A",
  userDeactivated: "Usuário Desativado",
  userActivated: "Usuário Ativado",
  farmUsers: "Usuários da Fazenda",
  viewAndUpdateTheFarmsThisUserHasAccessTo: "Ver e atualizar as fazendas às quais este usuário tem acesso",
  assignFarmsToTheSelectedUsers: "Atribuir fazendas aos usuários selecionados",
  selectTheFarmsYouWantToGrantAccessToForTheChosenTechnicians: "Selecione as fazendas às quais deseja conceder acesso para os técnicos escolhidos.",
  removeAccessFromSelectedFarms: "Remover Acesso das Fazendas Selecionadas",
  grantFarmAccess: "Conceder Acesso à Fazenda",
  back: "Voltar",
  s: "(s)",
  loadingData: "Carregando dados...",
  areYouSureYouWantToGrantAccessTo: "Tem certeza de que deseja conceder acesso a",
  areYouSureYouWantToRemoveAccessFrom: "Tem certeza de que deseja remover o acesso de",
  farmAccessRemoved: "Acesso à Fazenda Removido",
  successfullyRemovedAccessFrom: "Acesso removido com sucesso de",
  failedToRemoveFarmAccessPleaseTryAgain: "Falha ao remover o acesso à fazenda. Por favor, tente novamente.",
  forTheFollowingUsers: "para o(s) seguinte(s) usuário(s)?",
  selectFarm: "Selecionar Fazenda",
  grantAccess: "Conceder Acesso",
  removeAccess: "Remover Acesso",
  removeFarmAccess: "Remover Acesso à Fazenda",
  farmAccessGranted: "Acesso à Fazenda Concedido",
  successfullyGrantedAccessTo: "Acesso concedido com sucesso a",
  farm: "fazenda",
  for: "para",
  user: "usuário",
  failedToGrantFarmAccessPleaseTryAgain: "Falha ao conceder acesso à fazenda. Por favor, tente novamente.",
  error: "Erro",
  selectFactory: "Selecionar Fábrica",
  failedToLoadFarmsPleaseTryAgain: "Falha ao carregar fazendas. Por favor, tente novamente.",
  farmNameAndId: "Nome e ID da Fazenda",
  farmAddedBy: "Fazenda Adicionada Por",
  exportAsCSV: "Exportar como CSV",
  of: "de",
  activityLog: "Registro de Atividades",


  youSharedAccessOfTheFarmWithTheFollowingUsersSuccessfully: "Você compartilhou o acesso da fazenda com o(s) seguinte(s) usuário(s) com sucesso.",
  grantAccessToMoreUsers: "Conceder Acesso a Mais Usuários",
  areYouSureYouWantToRemoveAccessFor: "Tem certeza de que deseja remover o acesso para",
  thisUser: "este usuário",
  areYouSureYouWantToGrantAccessToThisFarmForTheFollowingUsers: "Tem certeza de que deseja conceder acesso a esta fazenda para o(s) seguinte(s) usuário(s)?",
  failedToLoadUsersPleaseTryAgain: "Falha ao carregar usuários. Por favor, tente novamente.",
  successfullyRemovedUserAccessFromThisFarm: "Acesso do usuário removido com sucesso desta fazenda.",
  farmIdAndUserIdAreRequired: "ID da Fazenda e ID do Usuário são obrigatórios.",
  noUsersSelectedPleaseSelectAtLeastOneUser: "Nenhum usuário selecionado. Por favor, selecione pelo menos um usuário.",
  successfullyGrantedAccessToThisFarmFor: "Acesso concedido com sucesso a esta fazenda para",
  unknownUser: "Usuário Desconhecido",
  confirm: "CONFIRMAR",
  farmActivityLog: "Registro de Atividades da Fazenda",
  ipAddress: "Endereço IP",
  dateAndTime: "Data e Hora",
  module: "Módulo",
  activityDescription: "Descrição da Atividade",
  select: "Selecionar",
  addNewUsers: "Adicionar Novos Usuários",
  addUsersToFarm: "Adicionar Usuários à Fazenda",
  selectedUsers: "Usuários Selecionados",
  selectTheUsersToAddInFarmFromTheBelowListOfAllUserInACooperative: "Selecione os usuários para adicionar à fazenda na lista abaixo de todos os usuários de uma cooperativa.",
  reviewTheSelectedUsersAndAssignTheirAccessRoles: "Revise os usuários selecionados e atribua seus papéis de acesso.",
  allRoles: "Todas as Funções",
  userRegistrationDate: "Data de Registro do Usuário",
  deactivated: "Desativado",
  pleaseSelectAtLeastOneUser: "Por favor, selecione pelo menos um usuário",
  noUsersSelected: "Nenhum usuário selecionado",
  userRemoved: "Usuário removido",
  next: "PRÓXIMO",
  id: "ID",
  },


  plantation: {
    farmerName: "Nome do agricultor",
    phoneNumber: "Número de telefone",
    plantationName: "Nome da plantação",
    farm: "Propriedade",
    location: "Localização",
    updatePlantationStatus: "Atualizar Status da Plantação",
    update: "Atualizar",
  },
}